<div class="title" [innerHTML]="content" [ngClass]="{'small-title': contentType === 'small-title'}"></div>